import { useEffect } from 'react';
export var useWindowEvent = function useWindowEvent(eventName, eventHandler) {
  useEffect(function () {
    window.addEventListener(eventName, eventHandler);
    return function () {
      window.removeEventListener(eventName, eventHandler);
    };
  });
};